import "../../../../src/content/buenos-aires/buenos-aires.scss";
import * as React from 'react';
export default {
  React
};